import React from 'react';
import {NavLink} from 'react-router-dom';
import moment from 'moment';
import SelectFieldWrapper from 'modules/blocks/SelectFieldWrapper';
import {SubscribeButton} from '../../profile/components/SubscribeButton';
import {SUBSCRIPTIONS_PRICES} from '../constants';
import checkCircle from 'images/check_circle.svg';

export const TopicItem = ({
  topic,
  payments,
  handleClick,
  handleExamStripeModal,
  changeSubscriptionOption,
  subscriptionOption,
  }) => {
  const handleTopicClick = () => {
    handleClick(topic.tutorial_type);
  };
  const checkIsDateActive = date => {
    return moment(date, 'DD/MM/YYYY').add(1, 'year').isSameOrAfter(moment());
  };

  const filterActiveSubscription = payments.filter(payment => !payment.tutorial_title && moment(payment.start_date, 'DD/MM/YYYY').add(1, 'year').isSameOrAfter(moment()) && payment.status === 'success')[0];
  const isActive = payments.map(payment => payment.status === 'success' && checkIsDateActive(payment.start_date) && payment.tutorial_title).includes(topic.title) || (topic.tutorial_type === 'ckt' && filterActiveSubscription);
  const cost = subscriptionOption[topic.tutorial_type] ? SUBSCRIPTIONS_PRICES[topic.tutorial_type][subscriptionOption[topic.tutorial_type]] : (topic.tutorial_type === 'cct' ? 795 : 595);

  const renderCkt = type => {
    return (
      <div className='dashboard-options-list' style={{color: 'rgba(0, 0, 0, 0.87)'}}>
        <div>
          <img src={checkCircle} alt="checkCircle" style={{marginRight: '8px'}} />
          <p className="dashboard-option-text">
            {'20 high yield topics for the CKT'}
          </p>
        </div>
        <div>
          <img src={checkCircle} alt="checkCircle" style={{marginRight: '8px'}} />
          <p className="dashboard-option-text">
            {'Videos on question prep including key domains to cover'}
          </p>
        </div>
        <div>
          <img src={checkCircle} alt="checkCircle" style={{marginRight: '8px'}} />
          <p className="dashboard-option-text">
            {'Exam technique tips:'}
            <p className='dashboard-option-subtext'>{'reading CKT questions, keywords to watch out for, question formats, time management, common mistakes to avoid'}</p>
          </p>
        </div>
        {!isActive && (
          <div>
            <div className="input-wrap select-wrap">
              <SelectFieldWrapper
                elements={[{value: 0, title: 'ANNUAL SUBSCRIPTION - € 595'}, {value: 1, title: '6 MONTH SUBSCRIPTION - € 445'}, {value: 2, title: '3 MONTH SUBSCRIPTION - € 275'}]}
                placeholder=""
                name={type}
                value={subscriptionOption[type] ? subscriptionOption[type] : 0}
                onChange={changeSubscriptionOption}
                style={{position: 'absolute'}}
                fullWidth
                className="select"
                floatingLabelText="Choose subscription option:"
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  const renderCct = type => {
    return (
      <div className='dashboard-options-list'>
        <div>
          <img src={checkCircle} alt="checkCircle" style={{marginRight: '8px'}} />
          <p className="dashboard-option-text">
            {'17 sample CCT practice cases:'}
            <p className='dashboard-option-subtext'>including information for the simulator, doctor and detailed marking scheme as well as key learning points</p>
          </p>
        </div>
        <div>
          <img src={checkCircle} alt="checkCircle" style={{marginRight: '8px'}} />
          <p className="dashboard-option-text">
            {'60 common cases seen in GP practice'}
            <p className='dashboard-option-subtext'>presented via PowerPoint video recording</p>
          </p>
        </div>
        <div>
          <img src={checkCircle} alt="checkCircle" style={{marginRight: '8px'}} />
          <p className="dashboard-option-text">
            {'Tips on how to prepare:'}
            <p className='dashboard-option-subtext'>how to hit the criteria, common reasons for failing a case</p>
          </p>
        </div>
        {!isActive && (
          <div className="input-wrap select-wrap">
            <SelectFieldWrapper
              elements={[{value: 0, title: 'ANNUAL SUBSCRIPTION - € 795'}, {value: 1, title: '6 MONTH SUBSCRIPTION - € 645'}, {value: 2, title: '3 MONTH SUBSCRIPTION - € 475'}]}
              placeholder=""
              name={type}
              value={subscriptionOption[type] ? subscriptionOption[type] : 0}
              onChange={changeSubscriptionOption}
              style={{position: 'absolute'}}
              className="select"
              floatingLabelText="Choose subscription option:"
              fullWidth
            />
          </div>
        )}
      </div>
    );
  }

  const renderOptions = (type) => {
    switch(type) {
      case 'ckt':
        return renderCkt(type);
      case 'cct':
        return renderCct(type);
      default:
        return;
    }
  }

  return (
    <div className='exam-prep-dashboard-option'>
      <div className='option-top'>
        <p className='option-title'>{`${topic.title}`}</p>
        <div className='divider' />
        {/* {!isActive && (
          <div className='price-block'>
            <p className='price'>€ 595</p>
            <p className='price-text'>for an annual subscription</p>
          </div>
        )} */}
      </div>
      {renderOptions(topic.tutorial_type)}
      {isActive ? (
        <NavLink
          className="btn rounded blue purchase-btn"
          to={`/exam-prep/topic/${topic.id}`}
          onClick={handleTopicClick}>
            {`Access ${topic.title}`}
        </NavLink>
      ) : (
        <SubscribeButton topic={topic} onClick={handleExamStripeModal} title={`€ ${cost} – PURCHASE NOW`} />
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/examPrepDashboard/components/TopicItem.jsx